module.exports = __webpack_public_path__ + "img/03.82af8722.png";